import { all, takeEvery, put } from 'redux-saga/effects'
import store from 'store'
import { store as reduxStore } from 'index'
import actions from './actions'

// Derived from the window on every load and resize, so never worth persisting.
const VIEWPORT_FLAGS = ['isMobileView', 'isTabletView', 'isMobileMiniView', 'isMobileXSView']

export function* CHANGE_SETTING({ payload: { setting, value, featureLabel = '' } }) {
  if (!VIEWPORT_FLAGS.includes(setting)) yield store.set(`app.settings.${setting}`, value)
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      [setting]: value,
      featureLabel,
    },
  })
}

export function* SETUP() {
  // Older builds persisted the viewport flags; drop them so they stop lingering in localStorage.
  VIEWPORT_FLAGS.forEach(flag => store.remove(`app.settings.${flag}`))

  const previous = {}
  const syncViewportFlag = (setting, currentState, load) => {
    if (currentState !== previous[setting] || load) {
      previous[setting] = currentState
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: { setting, value: currentState },
      })
    }
  }

  const isMobileView = (load = false) =>
    syncViewportFlag('isMobileView', global.window.innerWidth <= 768, load)
  const isTabletView = (load = false) =>
    syncViewportFlag('isTabletView', global.window.innerWidth < 1200, load)
  const isMobileMiniView = (load = false) =>
    syncViewportFlag('isMobileMiniView', global.window.innerWidth < 575, load)
  const isMobileXSView = (load = false) =>
    syncViewportFlag('isMobileXSView', global.window.innerWidth < 441, load)

  yield isMobileView(true)
  yield isTabletView(true)
  yield isMobileMiniView(true)
  yield isMobileXSView(true)
  yield window.addEventListener('resize', () => {
    isMobileView()
    isTabletView()
    isMobileMiniView()
    isMobileXSView()
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CHANGE_SETTING, CHANGE_SETTING),
    SETUP(), // run once on app load to init listeners
  ])
}
